import React from 'react';
import { Helmet } from 'react-helmet';
import styles from './styles.module.scss';

import { spanish } from '../../config/config';
import Summary from '../../components/Cart/Summary';
import CrossSale from '../../components/Cart/CrossSale';

const Cart = () => (
  <div className={styles.container}>
    <Helmet title={spanish ? 'Bolsa de compras' : 'Shopping Bag'} />
    <Summary />
    <CrossSale />
  </div>
);

export default Cart;
